<template>

  <BibimbapBody />

</template>


<script>
import BibimbapBody from '../molecules/BibimbapBody.vue'

export default {
  name: 'BibimbapView',
  components: {
    BibimbapBody,
  }
}
</script>
